module.exports = __webpack_public_path__ + "static/nicole-baumgarth-22dbc4ffc3363a5821d546b8d92b65b0.png";